import {ResponseType} from "../../enums/response-type.enum"

export class Response<T>{
  code: ResponseType;  
  message: string;
  responseData: T;

  
  constructor(_code:ResponseType, _message: string, _responseData: T){
    this.code = _code;
    this.message = _message;
    this.responseData = _responseData;
  }
}